import { Anchor, Avatar, Badge, Group, SimpleGrid, Stack, Text } from "@mantine/core";
import StatusText from "../../../../common/components/DataTable/StatusText";
import TripDrawerField from "./TripDrawerField";
import { getTravellerInitials, getTravellerName, formatGender } from "../../utils/allPolicyHelpers";
import classes from "./TripPolicyDrawer.module.css";

const passportOrAadharLabel = (coverType) =>
  String(coverType || "").toLowerCase() === "domestic" ? "Aadhar No." : "Passport No.";

const TripDrawerTravellerCard = ({ traveller, coverType, onTravellerClick }) => (
    <div
      className={`${classes.travellerCard}${onTravellerClick ? ` ${classes.travellerCardClickable}` : ""}`}
      onDoubleClick={onTravellerClick ? () => onTravellerClick(traveller) : undefined}
    >
      <Group justify="space-between" align="flex-start" wrap="wrap" mb="md" className={classes.travellerTop}>
        <Group gap="sm" wrap="wrap" className={classes.travellerMeta}>
          <Avatar radius="xl" color="orange">{getTravellerInitials(traveller)}</Avatar>
          <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
            <Group gap={6} wrap="wrap">
              <Text fw={700} size="sm" style={{ wordBreak: "break-word" }}>{getTravellerName(traveller)}</Text>
              {traveller.is_primary ? <Badge size="xs" color="orange">Primary</Badge> : null}
            </Group>
            <Text size="xs" c="dimmed" style={{ wordBreak: "break-word" }}>
              {[traveller.nationality_name, formatGender(traveller.gender), traveller.dob ? `DOB: ${traveller.dob}` : null]
                .filter(Boolean)
                .join(" · ")}
            </Text>
          </Stack>
        </Group>
        <Group gap={6} className={classes.travellerBadges}>
          <StatusText status={traveller.status} field="status" />
          <StatusText
            status={traveller.policy_status_traveller_wise}
            field="policy_status_traveller_wise"
          />
        </Group>
      </Group>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        <TripDrawerField label="Email" value={traveller.email} />
        <TripDrawerField label="Phone" value={traveller.phone_number} />
        <TripDrawerField
          label={passportOrAadharLabel(traveller.cover_type ?? coverType)}
          value={traveller.passport_number}
        />
        <TripDrawerField label="Cover No." value={traveller.cover_number} />
        <TripDrawerField
          label="Nominee"
          value={
            traveller.nominee_name
              ? `${traveller.nominee_name}${traveller.nominee_relation ? ` (${traveller.nominee_relation})` : ""}`
              : "—"
          }
        />
        <TripDrawerField label="Nationality" value={traveller.nationality_name} />
      </SimpleGrid>

      {traveller.cover_document ? (
        <Stack gap={6} mt="md">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>Documents</Text>
          <Anchor
            href={traveller.cover_document}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            onClick={(event) => event.stopPropagation()}
          >
            Cover Doc
          </Anchor>
        </Stack>
      ) : null}
    </div>
);

export default TripDrawerTravellerCard;
